import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import styled from 'styled-components'
import { Select, DatePicker } from 'antd'
import moment from 'moment';
const { RangePicker } = DatePicker;
const { Option } = Select;

const FlexWrapper = styled.div`
  display:flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  & > * {
    margin-left: 10px;
  }
`

const InputWrapper = styled.div`
  display:flex;
  align-items: center;
  & > div{
    margin-right: 10px;
  }
`
const ChartWrapper = styled.div`
  padding: 16px 20px;
  background-color: #ffffff;
`
Highcharts.setOptions({
    lang:{
        months:[
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ]
    }});

class TransChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      range: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')],
      coin: 'BTC',
      type: 0,
    }
  }

  componentDidMount() {
    this.request()
  }

  request = () => {
    this.props.fetchFunction({ coin: this.state.coin, type: this.state.type, begin: this.state.range[0].unix(), end: this.state.range[1].unix() });
  }

  handleTransCoinChange = (value) => {
    this.setState({ coin: value }, this.request)
  }

  handleTransTypeChange = (value) => {
    this.setState({ type: value }, this.request)
  }

  handleTransRangeChange = (value) => {
    value[1] = value[1].endOf('day')
    this.setState({ range: value }, this.request)
  }

  render() {
    return (
      <ChartWrapper>
        <FlexWrapper>
          <InputWrapper>
            <div>Đồng:</div>
            <Select
              placeholder="Chọn đồng bạn muốn"
              style={{ width: 120 }}
              onChange={this.handleTransCoinChange}
              defaultValue={this.state.coin}
            >
              {this.props.coins.map((item) => (
                <Option value={item.coin}>{item.coin}</Option>
              ))}
            </Select>
          </InputWrapper>
          <InputWrapper>
            <div>Loại:</div>
            <Select
              placeholder="Chọn đồng bạn muốn"
              style={{ width: 120 }}
              onChange={this.handleTransTypeChange}
              defaultValue={0}
            >
              <Option value={0}>Nạp</Option>
              <Option value={1}>Rút</Option>
            </Select>
          </InputWrapper>
          <InputWrapper>
            <div>Thời gian:</div>
            <RangePicker
              defaultValue={this.state.range}
              onChange={this.handleTransRangeChange}
              disabledDate={(current) => current && current > moment().endOf('day')}
            />
          </InputWrapper>

        </FlexWrapper>
        <HighchartsReact highcharts={Highcharts} options={{
          chart: {
            type: 'spline'
          },
          
          title: {
            text: this.props.name
          },
          xAxis: {
            type: 'datetime',
            labels: {
              format: "{value:%e/%B/%Y}",
            },
          },
          yAxis: {
          },
          series: [
            {
              name: "Tổng giao dịch",
              data: this.props.trans.map((item) => ([item.time_stamp * 1000, item.total_amount]))
            },
            {
              name: "Phí giao dịch",
              data: this.props.trans.map((item) => ([item.time_stamp * 1000, item.total_fee]))
            },
            {
              name: "Lượt giao dịch",
              data: this.props.trans.map((item) => ([item.time_stamp * 1000, item.total_count]))
            }
          ]
        }} />
      </ChartWrapper>
    );
  }
}

export default TransChart;